import React from 'react';
import './IndiaMap.css';

export default function IndiaMap({ states, onStateSelect, lang, faithSet }) {
  const L = (en, hi) => lang === 'en' ? en : hi;

  const getCount = (s) => {
    if (!faithSet || faithSet.size === 0 || faithSet.size === 3) return s.temple_count;
    let count = 0;
    if (faithSet.has('hindu'))    count += (s.hindu_count    || 0);
    if (faithSet.has('buddhist')) count += (s.buddhist_count || 0);
    if (faithSet.has('jain'))     count += (s.jain_count     || 0);
    return count;
  };

  return (
    <div className="state-grid-wrap">
      <h2 className="state-grid-heading">
        {L('Explore Sacred South India', 'पवित्र दक्षिण भारत देखें')}
      </h2>
      <p className="state-grid-sub">
        {L('Select a state to explore its temples', 'मंदिर देखने के लिए राज्य चुनें')}
      </p>
      <div className="state-grid">
        {states.map(s => (
          <button key={s.id} className="state-grid-card" onClick={() => onStateSelect(s)}>
            <span className="sgc-name">{lang === 'en' ? s.name_en : s.name_hi}</span>
            <span className="sgc-count">{getCount(s)}</span>
            <span className="sgc-label">{L('temples', 'मंदिर')}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
